import React from 'react';
import { render } from 'react-dom';
import { createInertiaApp } from '@inertiajs/inertia-react';
import { InertiaProgress } from '@inertiajs/progress';
import * as Sentry from '@sentry/browser';

InertiaProgress.init({
  color: '#ED8936',
  showSpinner: true
});

Sentry.init({
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN
});

// const app = document.getElementById('app');
//
// render(
//   <InertiaApp
//     initialPage={JSON.parse(app.dataset.page)}
//     resolveComponent={name =>
//       import(`./Pages/${name}`).then(module => module.default)
//     }
//   />,
//   app
// );


createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  setup({ el, App, props }) {
    render(<App {...props} />, el)
  },
})
